<script>
import ModelShow from '@/components/models/show'
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import { models } from './data-models'
import appConfig from "@/app.config.json";
import Swal from "sweetalert2";

export default {
  page: {
    title: "Models",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelShow
  },
  props: {
    cardTitle: {default() { return undefined }},
    resourceRoute: {default: 'models'},
    modelVariable: {default: 'model'},
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('models.plural')),
      loading: false,
      model: this.modelVariable === 'model' ? models[this.$route.params.key - 1] : {},
    }
  },
  computed: {
    items() {
      return [
        {
          text: this.lodash.upperFirst(this.$t('models.plural')),
          href: "/models",
        },
        {
          text: this.model && this.model.id ? this.getModelName() : this.$route.params.key,
          href: `/models/${this.$route.params.key}`,
          active: true,
        }
      ]
    },
    modelMapped() {
      return this.lodash.isEmpty(this.model) ? [] : this.lodash.map(this.model, (value, key) => ({
        key: ['created_at', 'updated_at', 'description'].includes(key) ? this.lodash.upperFirst(this.$t(`models.${key}`)) : this.lodash.upperFirst(this.$t(`${this.resourceRoute}.${key}`)),
        value: value
      }))
    },
    relations() {
      return {
        [this.modelVariable || 'model']: [
          // {
          //   name: 'children',
          //   label: this.lodash.startCase(this.$t('models.children')),
          //   component: null,
          //   props: {},
          //   listeners: {}
          // }
        ]
      }
    }
  },
  methods: {
    getModelKey() {
      return this.model[this.modelKey || 'id'];
    },
    getModelName() {
      return this.model['name'] || this.getModelKey();
    },
    handleBack() {
      this.$router.back();
    },
    handleEdit() {
      this.$router.push({path: `edit`, append: true});
    },
    deleteConfirmAlert() {
      return Swal.fire({
        title: this.$t('Are you sure?'),
        text: this.$t(`You won't be able to revert this!`),
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill mx-1',
        cancelButtonClass: 'btn btn-danger btn-fill mx-1',
        confirmButtonText: this.$t('Yes, delete it!'),
        cancelButtonText: this.$t('Cancel'),
        buttonsStyling: false
      })
    },
    deleteSuccessAlert(something) {
      return Swal.fire({
        title: this.$t('Deleted') + '!',
        text: this.$t(`You deleted {something}`, {something}),
        type: 'success',
        confirmButtonClass: 'btn btn-success btn-fill',
        buttonsStyling: false
      })
    },
    failedAlert(error) {
      return Swal.fire({
        title: this.$t('Failed') + '!',
        text: (error.response && (error.response.data || {}).message) || error.message,
        type: 'danger',
        confirmButtonClass: 'btn btn-danger btn-fill',
        buttonsStyling: false
      })
    },
    delete() {
      return Promise.resolve({ data: {} })
    },
    handleDelete() {
      this.deleteConfirmAlert().then(result => {
        if (result.value) {
          this.delete()
            .then(() => this.deleteSuccessAlert(this.getModelName()))
            .then(() => this.$router.back())
            .catch((error) => this.failedAlert(error));
        }
      });
    },
    handlePrint(){
      const pageTitle = document.title;
      const id = this.model[this.modelKey || 'id'];
      document.title = `${this.lodash.startCase(this.$t(this.resourceRoute+'.singular'))}-${id}`;
      window.print();
      document.title = pageTitle;
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div>
      <div class="row">
        <keep-alive>
          <model-show
            :class="{
              'col-md-4': !!relations[modelVariable].length,
              'col-12': !relations[modelVariable].length
            }"
            :loading="loading"
            v-bind="$props"
            :value="model"
            :model-mapped="modelMapped"
            @back-click="handleBack"
            @edit-click="handleEdit"
            @delete-click="handleDelete"
            @print-click="handlePrint"
          ></model-show>
        </keep-alive>
        <div v-if="!!relations[modelVariable].length" class="col-md-8">
          <template
            v-for="(relation, index) in relations[modelVariable]"
          >
            <component
              :key="index"
              v-if="relation.component"
              :is="relation.component"
              v-bind="relation.props"
              v-on="relation.listeners"
            ></component>
          </template>
        </div>
      </div>
    </div>
  </Layout>
</template>
